import React, { useEffect, useCallback } from 'react'
import { Panel, Label, Progress, Container, Tool, Button, TyanEllipsisLabel } from '@sencha/ext-modern'
import { doUpload } from './fileServeDispatch'

import { FILESERVE_STATUS } from './fileServeStatus'
import { useInstData } from 'tyan/public/hooks'
import MyImage from './MyImage'

const MAXBLOCKSIZE = 1024 * 64

const NewFile = ({ file: { id, FileName, FileExt, FileSize = 0, blob, filePath, Text }, imageSize, param, onFileUploaded, onRemoveFile }) => {
	const { me, me: { state: state, setState, state: { url, progress, status, message } } } = useInstData(null, () => ({
		state: {
			xhr: null,
			url: imageSize ? window.URL.createObjectURL(blob) : null,
			offset: 0,
			progress: 0,
			status: FILESERVE_STATUS.UPLOADING,
			message: ''
		}
	}))

	const uploadFile = useCallback(() => {
		const onSuccess = ({ FID }) => onFileUploaded(id, FID)
		const onError = msg => setState({ xhr: null, status: FILESERVE_STATUS.ERROR, message: (msg || '上传失败') })
		const onProgress = progress => setState({ progress })

		setState({ xhr: doUpload({ blob, onSuccess, onError, onProgress, eventData: { FileSize, FileExt }, param }) })
	}, [])

	const uploadBase64 = useCallback(() => {
		// console.log('debug')
		// return
		// 'ReadFileData', // 读文件内容: fileName, offset, size; return: ret:fileData
		const { state: { FID, check, offset } } = me
		const size = Math.min(FileSize - offset, MAXBLOCKSIZE)
		Tyan.wsFrontEditor.ReadFileData({ fileName: filePath, offset, size }, ({ ret: data }) => {
			if (me.unmounted) return
			if (data) {
				Tyan.doPostEvent('UploadFileBase64', {
					data: { FID, check, fileName: `${FileName}.${FileExt}`, totalSize: FileSize, offset, size, base64: data },
					onEnd: ({ errorMessage, FID: newFID, check: newCheck }) => {
						if (me.unmounted) return
						if (errorMessage)
							setState({ status: FILESERVE_STATUS.ERROR, message: errorMessage })
						else {
							const newOffset = offset + size
							if (newOffset >= FileSize) onFileUploaded(id, newFID)
							else {
								setState({ FID: newFID, check: newCheck, offset: newOffset, progress: newOffset / FileSize * 100 })
								setTimeout(uploadBase64)
							}
						}
					}
				})
			} else {
				setState({ status: FILESERVE_STATUS.ERROR, message: `读取 ${fileType} 文件失败` })
			}
		})
	})

	useEffect(() => {
		FileSize <= 0 && setState({ message: '空文件', status: FILESERVE_STATUS.ERROR })
		blob ? uploadFile() : uploadBase64()

		return () => {
			state.xhr && state.xhr.abort()
			state.url && window.URL.revokeObjectURL(state.url)
		}
	}, [])

	const handRemoveFile = useCallback(() => onRemoveFile(id), [id])

	const renderNormal = (isImage = false) => <Panel layout={{ type: 'hbox', pack: 'start' }}
		{...isImage ? { ui: 'half-transparent', right: 0, bottom: 0, width: '100%' } : { maxWidth: '100%' }}
	>
		{!isImage && <Tool iconCls="x-fa fa-upload" ui='action size14' padding='0 4 0 0' />}
		<Container layout='vbox' style='flex-shrink: 1'
			{...isImage ? { flex: 1 } : {}}
		>
			<TyanEllipsisLabel margin="4 0 0 0"
				html={`${message ? message + ': ' : ''} ${Text}`} />
			<Container style='vbox' height={3}>
				{status != FILESERVE_STATUS.ERROR ? (<Progress value={progress / 100.0} />) : null}
			</Container>
		</Container>
		<Container layout='hbox' margin="0 0 0 5">
			<Container layout={{ type: 'hbox', pack: 'end' }} minWidth='30'>
				<Label html={`${message ? '' : (Math.ceil(progress) + '%')}`} padding="0" margin="4 0 0 0" />
			</Container>
			<Tool iconCls="x-fa fa-times" ui="size14 decline" padding='0 0 0 4' handler={handRemoveFile} />
		</Container>
	</Panel >

	const renderImage = () => <Container key={id} layout='vbox' margin='5'>
		<MyImage {...imageSize} src={url} fileName={FileName} />
		{renderNormal(true)}
	</Container>

	return imageSize ? renderImage() : renderNormal()
}

export default NewFile